<mat-label [class.validation-error-label]="showValidationError">{{ caption | translate }}</mat-label>
<mat-form-field [ngClass]="{ 'fx-fill': settings.fxFill }">
  <input class="input-cal"
    [mtxDatetimepicker]="datetimePicker"
    [ngModel]="value"
    (ngModelChange)="onValueChange($event)"
    [readonly]="settings.readonly"
    matInput
    required
  />
  <mtx-datetimepicker-toggle
    [for]="datetimePicker"
    matSuffix
  ></mtx-datetimepicker-toggle>
  <mtx-datetimepicker
    #datetimePicker
    [type]="type"
    [mode]="mode"
    [multiYearSelector]="multiYearSelector"
    [startView]="startView"
    [twelvehour]="twelvehour"
    [timeInterval]="timeInterval"
    [touchUi]="touchUi"
    [disabled]="settings.readonly"
  ></mtx-datetimepicker>
</mat-form-field>